// extracted by mini-css-extract-plugin
export default {"warp":"MdContentSelecter-module--warp--eHQuH","left":"MdContentSelecter-module--left--UvK-R","right":"MdContentSelecter-module--right--QsmIT"};